module.exports = __webpack_public_path__ + "img/mini-sale.da912237.svg";